import React from 'react';
import axios from 'axios';
import {Boton, Accion} from '../../comun/Index';
import Nuevo from './Nuevo';

class Listado extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      expandir:null
    }
  }

  expandir(id){
    const {expandir} = this.state;
    if (expandir !== id){
      this.setState({expandir:id});
    } else {
      this.setState({expandir:null});
    }
  }

  render(){
    const {expandir} = this.state;
    const {materias} = this.props;
    return(
      <div className="Lista">
        {materias.map((item, index) => {
          return(
            <div
              key={index}
              className="Item"
              style={{backgroundColor:index%2===1?'#e3e3e3':'#f0f0f0'}}
            >
              <div className="Detalles">
                <div style={{display:'flex', flexDirection:'row', alignItems:'flex-end'}}>
                  {item.nombre}
                </div>
                <div className="Acciones">
                  <Accion
                    icono="edit"
                    ayuda="Editar"
                    backgroundColor="#00a5e5"
                    disabled={true}
                    onClick={() => this.props.editar(index)}
                  />
                </div>
              </div>
            </div>
          )
        })}
      </div>
    );
  }
}
const getMaterias = function(){
  return new Promise(function(resolve, reject) {
    const url = localStorage.getItem('apiUrl') + '/emisores/todos/materias/'
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.get(url, config)
    .then((res) => {
      if (res.data.status === "ok"){
        resolve(res.data.materias)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  });
}



export default class Usuarios extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      materias:[],
      showModal:false,
      datosModal:{}
    }
  }

  componentDidMount(){
    this.actualizar();
  }



  async actualizar(){
    getMaterias()
    .then((materias) => this.setState({materias}))
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error")
    }) 
  }

  nuevo(){
    this.setState({datosModal:{},showModal:true});
  }

  // editar(index){
  //   this.setState({datosModal:this.state.usuarios[index]});
  //   this.setState({showModal:true});
  // }

  guardar(datos){
    const url = localStorage.getItem('apiUrl') + '/emisores/admin/materia';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.post(url, datos, config)
    .then((res) =>{
      if (res.data.status === "ok"){
        this.setState({showModal:false,datosModal:{}});
        this.actualizar();
      } else {
        alert(res.data.error);
      }
    })
    .catch((err) => {
      console.log(err);
    })
  }


  render(){
    const {showModal, datosModal, materias} = this.state;
    return(
      <div className="TramitesTodo">
        {showModal &&
          <Nuevo
            datos={datosModal}
            salir={() => {window.scrollTo(0,0);this.setState({showModal:false,datosModal:{}})}}
            guardar={(datos) => {window.scrollTo(0,0);this.guardar(datos)}}
          />
        }
        <h3>Materias</h3>
        <Listado
          materias={materias}
          editar={(index) => {window.scrollTo(0,0);this.editar(index)}}
        />
        <Boton
          backgroundColor="#00a5e5"
          titulo="Nuevo"
          onClick={() => {window.scrollTo(0,0);this.nuevo()}}
        />
      </div>
    );
  }
}
